import { render, staticRenderFns } from "./ManualUsuario.vue?vue&type=template&id=47f68000&scoped=true"
import script from "./ManualUsuario.vue?vue&type=script&lang=js"
export * from "./ManualUsuario.vue?vue&type=script&lang=js"
import style0 from "./ManualUsuario.vue?vue&type=style&index=0&id=47f68000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f68000",
  null
  
)

export default component.exports